import React from 'react';
import { ProfileMenu } from './ProfileMenu';
import styles from './style.module.scss';

export class TopBar extends React.Component {
  render() {
    return (
      <div className={styles.topbar}>
        <div>
          <h4>
            <strong>KYC DASHBOARD</strong>
          </h4>
        </div>
        <ProfileMenu />
      </div>
    );
  }
}
